import React from "react";
import "./sponsored.css";
import Hero from "./assets/hero-image.png";
import Benefit1 from "./assets/benefit1.png";
import Benefit2 from "./assets/benefit2.png";
import Benefit3 from "./assets/benefit3.png";
import Practice1 from "./assets/practice1.png";
import Practice2 from "./assets/practice2.png";
import Practice3 from "./assets/practice3.png";
import { Container, Grid2 } from "@mui/material";
import { motion } from "motion/react";
import SponsoredToolbar from "./sponsoredToolbar";
import Footer from "../../components/footer";

const Sponsored = () => {
  const cards = [
    {
      id: 1,
      title: "Prime Visibility",
      description:
        "Your profile appears at the top of search results when potential clients look for legal help. If a client's search aligns with your expertise, you'll be front and center, ensuring you capture their attention immediately.",
      image: Practice1,
      className: "sponsored-card1",
    },
    {
      id: 2,
      title: "Budget-Friendly Marketing",
      description:
        "Set your own ad spend limits and let our platform work within your budget to maximize your online exposure.",
      image: Practice2,
      className: "sponsored-card2",
    },
    {
      id: 3,
      title: "Actionable Insights",
      description:
        "Easily track your campaign’s performance with clear metrics, so you can make informed decisions to grow your practice.",
      image: Practice3,
      className: "sponsored-card3",
    },
  ];
  return (
    <div>
      <SponsoredToolbar />
      <div className="sponsored-page-container">
        {/* HERO SECTION */}
        <section className="sponsored-hero">
          <div className="sponsored-hero-content">
            <h1 className="sponsored-hero-title">Reach more new clients</h1>
            <p className="sponsored-hero-description">
              Sponsored Results is paid advertising on our legal platform. On
              average, participating lawyers experience a significant increase
              in consultation requests—enabling you to connect with more
              potential clients quickly and effectively.
            </p>
            <button className="sponsored-cta-button">Learn More</button>
          </div>
          {/* Placeholder for Hero Image */}
          <div className="sponsored-hero-image">
            <img
              src={Hero}
              alt="Hero Placeholder"
              className="sponsored-hero-img"
            />
          </div>
        </section>

        {/* BENEFITS SECTION */}
        <section className="sponsored-benefits">
          <h2 className="sponsored-section-title">
            Discover the Benefits of Sponsored Results
          </h2>
          <div className="sponsored-benefits-grid">
            <div className="sponsored-benefit-item">
              <div className="sponsored-benefit-icon">
                <img
                  src={Benefit1}
                  alt="Placeholder Icon 1"
                  className="sponsored-image"
                />
              </div>
              <h3 className="sponsored-benefit-title">
                Outcome-Driven Control
              </h3>
              <p className="sponsored-benefit-description">
                Set your maximum fee per consultation so you only invest what
                fits your practice’s budget.
              </p>
            </div>

            <div className="sponsored-benefit-item">
              <div className="sponsored-benefit-icon">
                <img
                  src={Benefit2}
                  alt="Placeholder Icon 2"
                  className="sponsored-image"
                />
              </div>
              <h3 className="sponsored-benefit-title">Optimized Visibility</h3>
              <p className="sponsored-benefit-description">
                Your profile gets top placement in the most relevant searches,
                ensuring more potential clients find you.
              </p>
            </div>

            <div className="sponsored-benefit-item">
              <div className="sponsored-benefit-icon">
                <img
                  src={Benefit3}
                  alt="Placeholder Icon 3"
                  className="sponsored-image"
                />
              </div>
              <h3 className="sponsored-benefit-title">Transparent Pricing</h3>
              <p className="sponsored-benefit-description">
                Enjoy peace of mind knowing your cost per consultation will
                never exceed your set limit—no hidden fees.
              </p>
            </div>
          </div>
        </section>

        {/* ELEVATION SECTION */}
        <div className="sponsored-key-features-section">
          <h2 className="sponsored-section-title">
            How Sponsored Results Elevates Your Practice
          </h2>
          <motion.div
            className="sponsored-container"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 1 }}
          >
            {cards.map((card, index) => (
              <motion.div
                className={`sponsored-card ${
                  index % 2 === 0
                    ? "sponsored-card-layout-reverse"
                    : "sponsored-card-layout-normal"
                }`}
                key={card.id}
                initial={{ y: 50 }}
                whileInView={{ y: 0 }}
                transition={{ type: "spring", stiffness: 50 }}
              >
                <div className="sponsored-card-content">
                  <h2 className="sponsored-card-title">{card.title}</h2>
                  <p className="sponsored-card-description">
                    {card.description}
                  </p>
                </div>
                <img
                  src={card.image}
                  alt={card.title}
                  className={card.className}
                />
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* TESTIMONIALS SECTION */}
        <section className="sponsored-testimonials" />

        {/* CALL TO ACTION SECTION */}
        <section className="sponsored-cta-section">
          <h2 className="sponsored-cta-title">Get started today</h2>
          <p className="sponsored-cta-subtitle">
            Have more questions? We’re happy to help.
            <br /> Contact us at{" "}
            <a href="mailto:connect@quidpro.ai" className="sponsored-email-link">connect@quidpro.ai</a>
          </p>
          <button className="sponsored-cta-button">Join Now</button>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Sponsored;
